/**
* @Author: zachalam
* @Date:   2017-01-19T17:09:30-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:09:56-08:00
*/

import React, { Component } from 'react';
import _ from 'lodash';

class BillingOrderContainer extends Component {

  componentWillMount() {
    window.location = "/billing";
  }

  render() {
    return null;
  }
}

export default BillingOrderContainer;



// WEBPACK FOOTER //
// ./src/containers/BillingOrderContainer.jsx